import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export const SectionWrapper = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => {
  return <section id={id} className={`py-20 md:py-32 px-4 ${className}`} data-id="element-173">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-6xl mx-auto" data-id="element-174">
        {children}
      </motion.div>
    </section>;
};
export const CTAButton = ({
  children,
  className = '',
  href = 'https://openforgeworks.com/cart/53250817196397:1',
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}) => {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Hombre Apagado No Más',
        content_type: 'product',
        value: 27000,
        currency: 'COP'
      });
    }
    if (onClick) onClick();
  };
  return <a href={href} onClick={handleClick} className={`
        group relative inline-flex items-center justify-center gap-3 
        bg-gold-500 text-dark-900 font-oswald font-bold text-lg md:text-xl uppercase tracking-wider 
        py-4 px-8 md:px-12 rounded-lg overflow-hidden
        shadow-[0_0_30px_rgba(212,165,116,0.25)] 
        hover:shadow-[0_0_50px_rgba(212,165,116,0.4)] 
        transition-all duration-300 transform hover:-translate-y-1
        ${className}
      `} data-id="element-175">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-176"></div>
      <span className="relative z-10 flex items-center gap-2" data-id="element-177">
        <Zap className="w-5 h-5 md:w-6 md:h-6 fill-dark-900" data-id="element-178" />
        {children}
      </span>
    </a>;
};